module.exports = __webpack_public_path__ + "static/media/91.043f6122.png";